import React, { Component } from "react";
import { Button, Card, Spin, Input, message } from "antd";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { fetchDeviationMatrix } from "store/actions"
import { Table } from "components/table";
import { DEVIATION_MATRIX_COLUMNS } from "../../constants/columns";
import PropTypes from "prop-types";
import { STATE_STATUS } from "../../constants";
import { List } from "immutable";
import { OnboardingService } from '../../services';
const { TextArea } = Input;
import QueryString from "query-string";

const onCellGenerator = (handleSave, _) => record => {
    return ({
        record,
        editable: true,
        dataIndex: _.dataIndex,
        title: record.header || _.title,
        handleSave,
        rules: record.rules || _.rules,
        fieldType: record.fieldType || _.fieldType,
        filesMultiple: _.filesMultiple ? _.filesMultiple : false,
        options: record.options || _.options,
        viewable: true,
        max: record.max
    })
};


class DeviationMatrixReview extends Component {

    state = {
        apiData: { "mitigants": {}, "ccm_recommendation": this.props.deviationMatrixReviewData?.size && this.props.deviationMatrixReviewData?.get("ccm_recommendation") || "" },
        loader: false
    }

    componentDidMount() {
        this.props.fetchDeviationMatrix(this.props.currentMpaId);
    }

    componentDidUpdate(prevProps) {
        if (this.props.deviationMatrixReviewStatus == STATE_STATUS.FETCHED && prevProps.deviationMatrixReviewStatus == STATE_STATUS.FETCHING) {
            this.setState(prev => ({ apiData: { ...prev.apiData, "ccm_recommendation": this.props.deviationMatrixReviewData?.size && this.props.deviationMatrixReviewData?.get("ccm_recommendation") || "" } }))
        }
    }

    getCustomTag = (_, key) => {
        if (key === "result") {
            return <div><label
                className="txt-light br-4"
                style={{ backgroundColor: _ === true ? "rgb(134 220 134)" : _ === false ? "rgb(238 142 142)" : null, padding: "0 10px 0 10px", display: "inline-block", width: "40%", textAlign: "center" }}
            >
                {String(_)}
            </label></div>
        }
        return <TextArea rows={4} />
    }


    handleSaveMultipleEntries = (record, values) => {
        const data = {}
        data[record.parameter] = values.mitigant
        this.setState({ apiData: { ...this.state.apiData, "mitigants": { ...this.state.apiData["mitigants"], ...data } } })
    }

    handleSaveButtonClick = () => {
        const { apiData } = this.state;
        const missingMitigants = this.props.deviationMatrixReviewData?.get("deviations")
            .filter(item => item.result === false && item.mitigant === null)
            .map(item => item.parameter);

        const missingParams = missingMitigants.filter(param => !apiData.mitigants[param]);

        if (missingParams.length > 0) {
            message.error(`Please provide mitigants for the following parameters: ${missingParams.join(", ")}`);
            return false;
        }
        if(!apiData.ccm_recommendation){
            message.error("Please fill CCM Recommendation field");
            return false
        }

        this.setState({ loader: true })
        OnboardingService.postCompanyBackgroundApi("patch",
            this.props.deviationMatrixReviewData && this.props.deviationMatrixReviewData.size &&
            this.props.deviationMatrixReviewData?.get("id"), apiData).then(res => {
                if (res.status === 200) {
                    message.success("Data Updated")
                }
            }).catch((err) => {
                console.log("inside catch deviation", err);
                message.error(err ? (err?.data?.detail || (typeof err?.data === "object" && Object.values(err)[0])) : "Something went wrong")
            }).finally(() => {
                this.setState({ loader: false })
            })

    };

    onChangeCCM = (e) => {
        const value = e.target.value;
        this.setState(prev => ({ apiData: { ...prev.apiData, "ccm_recommendation": value } }))
    }

    downloadDeviationReport = () => {
        const params = { mpa_approval_id: this.props.currentMpaId, download: "yes" }
        OnboardingService.fetchDeviationMatrixApi(params).then(res => {
            if (res.status === 200 && res.data.file) {
                const link = document.createElement('a');
                link.href = res.data.file;
                link.setAttribute('target', '_blank');
                link.setAttribute('download', 'Deviation_Report.xlsx');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }).catch((err) => {
            console.log("inside catch", err);
        })
    }

    render() {
        const searchParams = QueryString.parse(window.location.search);
        return (
            <Card title={"Anchor Policy"} className="d-flex flex-column align-items-flex-end padless-card pb-10">
                <Spin spinning={this.props.deviationMatrixReviewStatus === STATE_STATUS.FETCHING}>
                    <Table
                        bordered
                        className="components-table-demo-nested p-10 ant-col padless-card"
                        size="middle"
                        pagination={false}
                        showTopSection={false}
                        editable={true}
                        columns={DEVIATION_MATRIX_COLUMNS(this.getCustomTag).map(({ editable, ...restColFields }) => {
                            if (!onCellGenerator || !editable) {
                                return { ...restColFields };
                            }
                            return {
                                onCell: onCellGenerator(
                                    this.handleSaveMultipleEntries,
                                    restColFields,
                                ),
                                ...restColFields
                            };
                        })}
                        data={this.props.deviationMatrixReviewData && this.props.deviationMatrixReviewData.size ? List(this.props.deviationMatrixReviewData?.get("deviations")) : List()}
                        showFilters={false}
                        showColumnSelector={false}
                        showDocumentFilter={false}
                        showFilterBtn={false}
                        noRowSelection={true}
                    />
                </Spin>
                <br />
                <div className="d-flex flex-column align-items-end m-10">
                    <div className="d-flex flex-column w-100">
                        <h4> CCM Recommendation </h4>
                        <TextArea
                            value={this.state.apiData.ccm_recommendation}
                            onChange={this.onChangeCCM}
                            required={true}
                            allowClear
                            className="w-40"
                            rows={4}
                            placeholder=""
                        />
                    </div>
                    <div className="d-flex w-100 justify-content-space-between">
                        <Button className="w-40 mt-10" disabled={this.state.loader || searchParams.stage !== "50"} type="primary" onClick={this.handleSaveButtonClick}>Save</Button>
                        <Button className="w-40 mt-10" type="primary" onClick={this.downloadDeviationReport}>Download Report</Button>
                    </div>
                </div>
            </Card>
        );
    }
}

DeviationMatrixReview.propTypes = {
    deviationMatrixReviewData: PropTypes.func,
    deviationMatrixReviewStatus: PropTypes.func
};

const mapStateToProps = (state, props) => {
    return {
        deviationMatrixReviewData: state.onboardingData.getIn(["deviationMatrixReview", "data"]),
        deviationMatrixReviewStatus: state.onboardingData.getIn(["deviationMatrixReview", "status"]),
    }
}

const mapDispatchToProps = dispatch => bindActionCreators({
    fetchDeviationMatrix
}, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(DeviationMatrixReview);
